<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div class="btn-box">
        <button-add :pathName="addDataParkHonor" v-if="permissionCodes.indexOf('034003001') !== -1"/>
        <button-cancel @cancel="showAttendanceDaysConfigurationVisible" value="应出勤天数配置" style="margin-left: 10px;"/>
        <!--<button-delete @deleteSelection="deleteSelection" />-->
      </div>
      <input-search placeholder="岗位名称" @search="searchKey" />
    </div>
    <table-main :selection="false" :tableHead="tableHead" :tableData="tableData" @deleteLine="deleteLine" :deleteTipInfo="'是否确认删除该岗位？'" @goToModifyPage="goToModifyPage" @changeSelection="changeSelection" :total="total" :pageNum="requestData.pageNum" :pageSize="requestData.pageSize" :operationArr="operationArr" @changePagination="changePagination" />

    <el-dialog title="出勤天数配置" :visible.sync="attendanceDaysConfigurationVisible" width="60%">
      <div class="search-line">
        <div class="btn-box">
          <el-date-picker v-model="configMonth" type="month" format='yyyy-MM' value-format="yyyy-MM" size="small" style="width: 280px" placeholder="排班日期"></el-date-picker>
        </div>
        <input-search placeholder="岗位名称" @search="configSearchKey" />
      </div>
      <table-main :selection="false" :tableHead="configTableHead" :tableData="configTableData" @wantChangeInput="wantChangeInput" @changeInputChange="changeInputChange" :total="configTotal" :pageNum="configRequestData.pageNum" :pageSize="configRequestData.pageSize" :hasOperation="false" @changePagination="changeConfigPagination"/>
    </el-dialog>
  </div>
</template>

<script>
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import ButtonAdd from '../../../components/Button/ButtonAdd'
  import ButtonDelete from '../../../components/Button/ButtonDelete'
  import ButtonExport from '../../../components/common/buttons/button-export'
  import ButtonUpload from '../../../components/common/buttons/button-upload'
  import InputSearch from '../../../components/Input/InputSearch'
  import InputSelect from '../../../components/Input/InputSelect'
  import TableMain from '../../../components/Table/TableMain'
  import {api} from '../../api/AttendancePoint'
  import {errorHandler} from '../../../utils/errorHandler'
  import {nAlert, nError, nSuccess} from '../../../utils/notice'
  import {bus} from '../../../utils/bus'
  import ButtonCancel from "../../../components/Button/ButtonCancel";

  export default {
    components: {
      ButtonCancel,
      TableMain,
      InputSelect,
      InputSearch,
      ButtonUpload,
      ButtonExport,
      ButtonDelete,
      ButtonAdd,
      Breadcrumb
    },
    name: 'attendance-position-manage',
    data () {
      return {
        permissionCodes: '',
        breadcrumb: [{
          value: '智慧考勤',
          name: 'attendance-department-manage'
        }, {
          value: '岗位管理'
        }],
        addDataParkHonor: 'attendance-position-add',
        operationArr: ['modify', 'delete'],

        tableHead: [{
          prop: 'positionName',
          label: '岗位名称'
        }, {
          prop: 'deptName',
          label: '所属部门'
        }, {
          prop: 'days',
          label: '当月应出勤天数(天)'
        }],
        tableData: [],
        total: 0,
        selectionArr: [],
        requestData: {
          searchKey: '',
          pageSize: 10,
          pageNum: 1,
        },

        attendanceDaysConfigurationVisible: false,
        configTableHead: [
          {
            prop: 'positionName',
            label: '岗位名称'
          }, {
            prop: 'deptName',
            label: '所属部门'
          }, {
            prop: 'month',
            label: '月份'
          }, {
            prop: 'days',
            label: '应出勤天数(天)',
            changeInput: true,
          }
        ],
        configTableData: [],
        configTotal: 0,
        configMonth: '',
        configRequestData: {
          searchKey: '',
          pageSize: 10,
          pageNum: 1,
          startTime: '',
          endTime: ''
        }
      }
    },
    created () {
      this.permissionCodes = bus.global.permissionCodes
      this.getPage()
    },
    activated() {
      this.getPage()
    },
    methods: {
      getPage () {
        this.$axios.post(api.getAttendancePositionPage, this.requestData)
          .then(res => {
            if (res.data.retCode === 1) {
              let data = res.data.data.list
              data.map(v => {})
              this.total = res.data.data.total
              this.tableData = data
            }
          })
          .catch(errorHandler('获取数据失败'))
      },
      search (v) {
        this.requestData[v.key] = v.value
        this.getPage()
      },
      searchKey (v) {
        this.requestData.pageNum = 1
        this.requestData.searchKey = v
        this.getPage()
      },
      changePagination (data) {
        this.requestData.pageNum = data[0]
        this.requestData.pageSize = data[1]
        this.getPage()
      },
      changeSelection (codeArr) {
        this.selectionArr = codeArr
      },
      goToModifyPage (code) {
        this.$router.push({
          path: '/attendance_position_modify/' + code
        })
      },

      deleteLine (code) {
        this.$axios.post(api.deleteAttendancePositionByCode, code)
          .then(res => {
            if (res.data.retCode === 1) {
              nSuccess('删除成功')
              this.selectionArr = []
              this.getPage()
            }
          })
          .catch(errorHandler('删除失败'))
      },

      // 展示应出勤天数
      showAttendanceDaysConfigurationVisible () {
        this.attendanceDaysConfigurationVisible = true
        this.getCurrentMonthInfo()
      },

      // 查询当月信息
      getCurrentMonthInfo () {
        let nowDate = new Date()
        let year = nowDate.getFullYear()
        let month = (nowDate.getMonth() + 1) < 10 ? '0' + (nowDate.getMonth() + 1) : (nowDate.getMonth() + 1)
        this.configMonth = `${year}-${month}`
        this.getPositionDaysPage()
      },

      // 查询出勤天数分页
      getPositionDaysPage () {
        this.configRequestData.startTime = this.configMonth || ''
        this.configRequestData.endTime = this.configMonth || ''
        this.$axios.post(api.getPositionDaysPage, this.configRequestData)
          .then(res => {
            if (res.data.retCode === 1) {
              let data = res.data.data.list
              data.map(v => {
                v.changeInputDisabled = true;
              })
              this.configTotal = res.data.data.total
              this.configTableData = data
            }
          })
          .catch(errorHandler('获取数据失败'))
      },

      configSearchKey(v) {
        this.configRequestData.pageNum = 1
        this.configRequestData.searchKey = v
        this.getPositionDaysPage()
      },

      changeConfigPagination (data) {
        this.configRequestData.pageNum = data[0]
        this.configRequestData.pageSize = data[1]
        this.getPositionDaysPage()
      },

      // 预修改
      wantChangeInput(data) {
        this.configTableData.map(v => {
          if (v.code === data.code) {
            v.changeInputDisabled = false;
          }
        });
      },

      // 修改出勤天数
      changeInputChange(data) {
        let reqData = {
          code: data.code,
          days: data.days
        };
        this.$axios.post(api.updatePositionDays, reqData)
          .then(res => {
            nSuccess("修改成功");
            this.getPositionDaysPage();
          })
          .catch(errorHandler("修改失败"));
      },
    },
    watch: {
      centEndTime(val) {
        this.getPage()
      },
      configMonth (v) {
        if (this.configMonth) {
          this.getPositionDaysPage()
        }
      }
    }
  }
</script>

<style scoped>
  .form-line {
    width: 420px;
    margin: 20px auto;
    display: flex;
    justify-content: flex-start;
  }
  .form-line>div {
    margin-right: 20px;
  }
  .line-text{
    color: #48576a;
    font-size: 14px;
    margin-right: 10px;
  }
  .textBox {
    display: inline-block;
    width: 122px;
    line-height: 32px;
    text-align: right;
  }
  .red {
    color: red;
  }
  .search-line {
    display: flex;
    justify-content: space-between;
    margin: 20px 0;
  }
  .btn-box {
    display: flex;
    justify-content: flex-start;
  }
</style>



// WEBPACK FOOTER //
// src/view/WorkAttendance/AttendancePosition/AttendancePositionManage.vue